import React, { useState } from "react";
import { Container, Col, Row } from "reactstrap";
import * as BucketQL from "queries/bucket";
import { Link } from "react-router-dom";
import { List } from "@repoflow/components/list-cursor";
import BucketSchema from "@common/schema/bucket/public";
import * as Section from "@repoflow/components/section";
import { SearchBox, SearchResults } from "./search";

export const Sidebar = () => null;

export const Indice = () => null;

export const Content = ({ match: { params } }) => {
  const { base } = Section.useSectionContext();

  // null = not searching, so the ordinary cursor-paged list shows. An empty
  // array is a search that matched nothing, which is a different thing.
  const [results, setResults] = useState(null);

  return (
    <Container>
      <div className="mt-4"></div>

      <Row>
        <Col md={4}>
          <Link className={"btn btn-primary"} to={`${base}/new`}>
            <i className="fa fa-plus" /> Add
          </Link>
        </Col>
        <Col md={8}>
          <SearchBox onResults={setResults} />
        </Col>
      </Row>

      <div className="mt-4"></div>

      {results !== null ? <SearchResults items={results} /> : <List
        path={"viewer.account.buckets"}
        query={BucketQL.list}
        variables={params}
        schema={BucketSchema}
        target={{ $ref: "/Public/Bucket" }}
        empty={"No buckets yet."}
        config={{
          "/Public/Bucket": {
            fields: ["description", "bucketId", "exts", "createdAt"],
          },
        }}
        content={({ item: { bucketId } }) => (
          <>
            <Link className={"btn btn-primary"} to={`${base}/${bucketId}/`}>
              View
            </Link>{" "}
          </>
        )}
      />}
    </Container>
  );
};
